import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {findFormPageByFormId} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceConfig";
import {loadOrCreateWorkspaceConfig} from "~/workspaceConfig/configRuntime";
import {resolveConfigFormHref as resolveConfigFormHrefFromConfig} from "~/workspaceConfig/configHref";

export function findConfigFormPageId(workspaceId: Uuid, formId: Uuid): string | undefined {
    return findFormPageByFormId(loadOrCreateWorkspaceConfig(workspaceId), formId)?.id;
}

export const resolveConfigFormHref = resolveConfigFormHrefFromConfig;
